if (!window.webshop) window.webshop = {}
if (!frappe.boot) frappe.boot = {}

// Add delivery/pickup badge below page title
frappe.ready(() => {
	const wrapper = document.querySelector('.page-header-wrapper');
	if (wrapper && !wrapper.querySelector('.delcol-badge')) {
		const badge = document.createElement('div');
		badge.className = 'delcol-badge';
		badge.innerHTML = '<img src="/files/purchserv2.png" alt="Click & Collect / Delivery">';
		wrapper.appendChild(badge);
	}
});
